/* eslint-disable jsx-a11y/anchor-is-valid */
import { default as React, useEffect } from 'react';
import "../assets/css/style/whatschat-style10.css";
import { default as linkGenerator } from "../helper/waLinksGenerator";

export default ({ title, phone, keyword, onChangeResize = null, onClickEvent = null }) => {
    const onClick = () => {
        const link = linkGenerator(phone, keyword);
        if (typeof onClickEvent === "function") onClickEvent(phone, keyword);
        window.open(link);
    };

    useEffect(() => {
        const buttonHtml = document.getElementById('wcBtn');
        const clientSize = { height: buttonHtml.offsetHeight + 30, width: buttonHtml.offsetWidth + 30 };
        if (typeof onChangeResize === "function") onChangeResize(clientSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="wc-style10" onClick={onClick}>
            <a id="wcBtn" className="wc-list wc-button2">
                <div className="wc-chat-icon">
                    <i className="fa fa-whatsapp" />
                </div>
                {title && <p>{title}</p>}
            </a>
        </div>
    );
};